module.exports = __webpack_public_path__ + "img/klara-avsenik-1406514-unsplash.d3fded82.jpg";